import React from "react";
import { isIntranetPath } from "../../lib/routing";
import { i18n } from "app/i18n/i18n";
import ccwLogo from "./images/ccw_logo2.png";

const CCW_URL = "http://websquare.intranet.jp.nomura.com/website83/ccw/index.html?link=GRP";

export const ContentCompanyLogo = () => {
  if (!shldShowContentLogo()) return null;

  return (
    <a
      className="content-company-logo position-relative"
      href={CCW_URL}
      title="当リンクは社内限で表示"
      target="_blank"
      rel="noopener noreferrer"
    >
      <img className="d-block" src={ccwLogo} alt="Content Company Logo" />
      <small className="position-absolute">社内限で表示されています</small>
    </a>
  );
};

const shldShowContentLogo = () => i18n.getLanguage() === "ja" && isIntranetPath();
